import {
  Box,
  GreyGrey60,
  GreyGrey90,
  Primary12Regular,
  Primary13SemiBold,
  TextOverflow
} from '@sequencehq/core-components'
import {
  customerFieldLabel,
  failingFieldGroups,
  parseFailingFields
} from 'lib/integrations/syncErrorFields'
import { formatList } from '@sequencehq/utils'
import { match } from 'ts-pattern'
import { CustomerImportFailure } from './customerImportsInFlight.types'

export const ImportRow = (props: {
  name: string
  failure?: CustomerImportFailure
}) => (
  <Box>
    <Box {...Primary13SemiBold} color={GreyGrey90}>
      <TextOverflow>{props.name}</TextOverflow>
    </Box>
    {props.failure ? (
      <Box {...Primary12Regular} color={GreyGrey60}>
        {formatImportFailureReason(props.failure)}
      </Box>
    ) : null}
  </Box>
)

export const formatImportFailureReason = (failure: CustomerImportFailure) => {
  const fields = parseFailingFields(failure.errorMessage)

  if (!fields) {
    return genericFailureReason(failure)
  }

  return `${failingFieldGroups(fields, customerFieldLabel)
    .map(group => `${group.label} ${formatList(group.fields).toLowerCase()}`)
    .join('. ')}. Update the company in HubSpot, then retry.`
}

const genericFailureReason = (failure: CustomerImportFailure) =>
  match(failure.errorCode)
    .with(
      'PULL_CREATE_FAILED',
      () =>
        'We couldn’t create this customer. Check the company details in HubSpot, then retry. If it still fails, contact support.'
    )
    .otherwise(
      () =>
        'We couldn’t import this customer. Retry, or contact support if it still fails.'
    )
